
import "./quality-control.css";
import qualityimg from "../images/quality-control.jpg"
import qualityimg1 from "../images/quality-control-1.png"


const QualityControl = () => {
    return (
        <>

            <div className="qc-container">
                <h1 className="qc-title">QUALITY CONTROL</h1>

                <p className="qc-subtitle">TREE-STAGE QUALITY CONTROL</p>

                <div className="qc-image-wrapper">
                    <img
                        src={qualityimg}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                 <div className="qc-content ">
                    <p>

                        Each product batch is being examined three times in the SCT Lubricants laboratory before it is packed and prepared for shipment. The laboratory is equipped with the most up-to-date devices and facilities the implementation of which mounted up to over 1,5 million euro in terms of investment.
                    </p>

                    <p>
                        All the tests are performed in the SCT laboratory, but in case a customer requires independent tests, external specialists might be involved.
                    </p>

                    <p>
                        All begins with the pre-production raw materials control. When both the base oil and the additives are approved, all the materials are proceeded to one of the four blending machines where they are heated and mixed up together. The technician takes a sample from the blending pipe which is thoroughly tested in the laboratory. This is the first stage of our quality control.
                    </p>
                </div>
            </div>
            <div className="qc-container">
                <div className="qc-image-wrapper">
                    <img
                        src={qualityimg1}
                        alt="Quality Control"
                        className="qc-image"
                    />
                </div>

                <div className="qc-content">
                    <p>
                        The second stage takes place during storage of the products in the tank park. This ensures no mud or water in the tank can seriously affect the quality. In case any deviations are found the whole tank is recycled.                        
                    </p>

                    <p>
                        The third and the last stage takes place just before the canisters are about to be filled. After the sample has been examined and approved, the filling process is initiated. All three samples are kept together in a laboratory refrigerator for 1-3 years, so they can be used in case of any complaint.
                    </p>

                    
                </div>

               
            </div>
        </>



    );
};

export default QualityControl;